// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__19W2Y","bigColWidth":"Table_bigColWidth__35RxA","biggerColWidth":"Table_biggerColWidth__3_JnC","row":"Table_row__24aH3","col":"Table_col__G-1b4"};